import { lazy } from 'react'

export const DeleteCallsVariant1 = lazy(() => import('./DeleteCallsVariant1'))
